const isBase64String = value => {
	const base64Regex =
		/^(data:image\/[a-zA-Z]+;base64,)?([A-Za-z0-9+/=]{4})*([A-Za-z0-9+/=]{2}==|[A-Za-z0-9+/=]{3}=)?$/;
	return base64Regex.test(value);
};
export { isBase64String };
